import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from 'hedron';
import { CloseImage, RefineCategory } from './RefineRowStyle';

const paddingStyle = isDesktop => (isDesktop ? '0 0 10px 1px' : '0 5px 10px 5px');

const RefineRow = ({ isDesktop, label, onClick, s3BasePath }) => (
  <div data-cy={`refine-by-${label.replace(/\s/g, '')}`}>
    <Row alignItems="center" style={{ padding: paddingStyle(isDesktop) }}>
      <Column xs={11} sm={11} md={11} fluid>
        <RefineCategory isDesktop={isDesktop}>{label}</RefineCategory>
      </Column>
      <Column xs={1} sm={1} md={1} fluid>
        <CloseImage
          data-cy="refine-by-remove-row"
          isDesktop={isDesktop}
          onClick={onClick}
          src={`${s3BasePath}mkt/icon/x_black.png`}
        />
      </Column>
    </Row>
  </div>
);

RefineRow.propTypes = {
  isDesktop: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  s3BasePath: PropTypes.string.isRequired,
};

export default RefineRow;
